import React, { useEffect, useState } from "react";
import {
	levelCalculator,
	currentLevelMinXp,
	nextLevel,
	statIconResolver,
} from "../../../util/helpers";
import { getRaiderExp } from "../../../util/web3/interactProfessions";
import { Box, Progress, Text, Flex, Spacer, Image } from "@chakra-ui/react";
import { Raider } from "../../../types/raider";

interface StatProps {
	raider: Raider;
	professionId: number;
	professionName: string;
}

export default function StatProgress(props: StatProps) {
	const [raider] = useState<Raider>(props.raider);
	const [statXp, setStatXp] = useState<number>();
	const [statLvl, setStatLvl] = useState<number>();
	const [currentLvlExp, setCurrentLvlExp] = useState<number>();
	const [nextLvlExp, setNextLevelExp] = useState<number>();
	const [statIcon, setStatIcon] = useState<string>();

	useEffect(() => {
		const fetchData = async () => {
			const xp = await getRaiderExp(Number(raider.id), props.professionId);
			if (xp != undefined) {
				setStatXp(xp);

				const lvl = levelCalculator(xp);
				setStatLvl(lvl);
				setCurrentLvlExp(currentLevelMinXp(lvl));
				setNextLevelExp(nextLevel(lvl));
				setStatIcon(statIconResolver(props.professionName))
			}
		};

		fetchData();
	}, []);

	return (
		<Box background="#4a556878" borderRadius="md" px={4} py={4}>
			<Flex mb="12px">
				<Image
					src={statIcon}
					alt={props.professionName}
					width="30px"
					height="30px"
					mr="5px"
				/>
				<Text textStyle="statsHeader" color="lightGreen">
					{props.professionName}
				</Text>
			</Flex>
			<Flex mb="5px">
				<Box
					backgroundImage="url('./levelSocket.png')"
					backgroundPosition="center"
					backgroundRepeat="no-repeat"
					backgroundSize="25px"
					width="25px"
					height="25px"
					alignItems="center"
					alignContent="center"
				>
					<Text
						width="100%"
						textAlign="center"
						fontWeight="700"
						pr="0.5"
						pt="0.4"
						fontSize="15px"
					>
						{statLvl}
					</Text>
					{/* <Image src="./levelSocket.png" alt="level" /> */}
				</Box>
				<Text ml="5px">Current Level</Text>
				<Spacer />
				{currentLvlExp != undefined && nextLvlExp != undefined && (
					<Text>
						Next Level: {statXp} / {Math.floor(currentLvlExp + nextLvlExp)}
					</Text>
				)}
			</Flex>
			{statXp != undefined &&
				currentLvlExp != undefined &&
				nextLvlExp != undefined && (
					<Progress
						value={((statXp - currentLvlExp) / nextLvlExp) * 100}
					></Progress>
				)}
		</Box>
	);
}
